import { isSSR } from './millesimaUtils';

export const getDescription = (initialText, textLength) => {
  // Replace heading tags (`<h1>Some title</h1><p>Text...</p>` becomes `Some title. <p>Text...</p>`)
  let text = initialText
    .replace(/<h[1-6]>/g, '')
    .replace(/<\/h[1-6]>/g, '. ');

  if (!isSSR()) {
    const div = document.createElement('div');
    div.innerHTML = text;
    text = div.textContent || div.innerText || text;
  } else {
    // Can't create a div here, simply strip all HTML tags
    text = text.replace(/<[^>]*>/g, '');
  }
  const end = text.lastIndexOf(' ') > textLength ? text.substring(0, textLength).lastIndexOf(' ') : text.length;

  return text.substring(0, end) + (end < text.length ? '...' : '');
};

export const getShortDescription = (text) => getDescription(text, 65);

export const getLongDescription = (text) => getDescription(text, 200);

export const isEmptyContent = (initialText) => {
  if (!initialText?.trim()) {
    return true;
  }

  const start = initialText.indexOf('<body>');

  if (start >= 0) {
    const end = initialText.indexOf('</body>');
    if (end >= 0 && end > start) {
      const str = initialText.substring(start + 6, end).trim();
      return !str;
    }
  }

  return false;
};
